import { Inbox } from 'lucide-react';
import { type ReactNode } from 'react';

interface Props {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
}

export function EmptyState({ icon, title, description, action }: Props) {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-6 text-center">
      <div className="h-16 w-16 rounded-full bg-canvas-hover text-navy-deep flex items-center justify-center mb-4">
        {icon ?? <Inbox className="h-7 w-7" />}
      </div>
      <h3 className="text-h3 text-ink">{title}</h3>
      {description && (
        <p className="mt-2 max-w-md text-body text-ink-muted">{description}</p>
      )}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}
